import {
  Component,
  computed,
  inject,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import { EEntityType, ERelationType, INormalText } from '@web/dtos';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { SiteContextService } from '../../../services/site-context/site-context.service';

@Component({
  selector: 'aw-loading-animation',
  imports: [LanguagePipe],
  templateUrl: './loading-animation.component.html',
})
export class LoadingAnimationComponent {
  public readonly entityType: InputSignal<EEntityType | undefined> = input();
  public readonly relationType: InputSignal<ERelationType | undefined> =
    input();
  private readonly textStore: WebTextStore = inject(WebTextStore);
  private readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  private readonly siteContextService: SiteContextService =
    inject(SiteContextService);
  protected readonly color: Signal<string | undefined> = computed(
    (): string | undefined =>
      this.siteContextService.isShopContext()
        ? this.corporateDesignService.primaryColor()
        : undefined
  );

  protected readonly loadingText: Signal<INormalText | undefined> = computed(
    (): INormalText | undefined => {
      const relationType: ERelationType | undefined = this.relationType();
      const entityType: EEntityType | undefined = this.entityType();
      return this.textStore
        .texts()
        .find(
          (text: INormalText) =>
            text.relationType === relationType && text.entityType === entityType
        );
    }
  );
}
